//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { catchError, map, Observable, of, switchMap, throwError } from 'rxjs';
import { EncryptionService } from '../general/encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../general/exceptions-service';
import { HttpClientService } from '../general/http-client-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { Injectable } from '@angular/core';
import { IntegerResultDTO } from 'src/app/core/interfaces/general/integer-result';
import { InviewUserDTO } from 'src/app/core/models/inview/inview-user.dto';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';

@Injectable({ providedIn: 'root' })

export class InviewUsersService {
  
  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public getCompanyUsersCount(inviewCompanyId: number, partialUsernameSearch: string | undefined): Observable<IntegerResultDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>inviewCompanyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const inviewCompanyIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<IntegerResultDTO>(environment.eSimApi +
                                                                                eSimApiPaths.InviewUsers + "/" +
                                                                                eSimApiPaths.InviewUsersGetCompanyUsersCount +
                                                                                "?inviewCompanyIdEncSS=" + inviewCompanyIdEncSS +
                                                                                (partialUsernameSearch==undefined || partialUsernameSearch.trim()==""
                                                                                 ?
                                                                                 ""
                                                                                 :
                                                                                 "&partialUsernameSearch=" + partialUsernameSearch
                                                                                )
                                                                               ); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getByCompanyId(inviewCompanyId: number): Observable<InviewUserDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>inviewCompanyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const inviewCompanyIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<InviewUserDTO[]>(environment.eSimApi +
                                                                               eSimApiPaths.InviewUsers +
                                                                               "?inviewCompanyIdEncSS=" + inviewCompanyIdEncSS); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getByUserId(inviewUserId: number): Observable<InviewUserDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>inviewUserId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const inviewUserIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<InviewUserDTO>(environment.eSimApi +
                                                                             eSimApiPaths.InviewUsers + "/" +
                                                                             eSimApiPaths.InviewUsersGetUserById +
                                                                             "?inviewUserIdEncSS=" + inviewUserIdEncSS); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getByCompanyId_ExcludeSureSimUsersIncAssociates(inviewCompanyId: number, partialUsernameSearch: string | undefined): Observable<InviewUserDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>inviewCompanyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const inviewCompanyIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<InviewUserDTO[]>(environment.eSimApi +
                                                                               eSimApiPaths.InviewUsers + "/" +
                                                                               eSimApiPaths.InviewUsersExcludeSureSimUsersIncAssociates +
                                                                               "?inviewCompanyIdEncSS=" + inviewCompanyIdEncSS +
                                                                               (partialUsernameSearch==undefined || partialUsernameSearch.trim()==""
                                                                                ?
                                                                                ""
                                                                                :
                                                                                "&partialUsernameSearch=" + partialUsernameSearch
                                                                               )
                                                                              ); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getByCompanyId_ExcludeSureSimEsimUsers(inviewCompanyId: number, partialUsernameSearch: string | undefined): Observable<InviewUserDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>inviewCompanyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const inviewCompanyIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<InviewUserDTO[]>(environment.eSimApi +
                                                                               eSimApiPaths.InviewUsers + "/" +
                                                                               eSimApiPaths.InviewUsersExcludeSureSimEsimUsers +
                                                                               "?inviewCompanyIdEncSS=" + inviewCompanyIdEncSS +
                                                                               (partialUsernameSearch==undefined || partialUsernameSearch.trim()==""
                                                                                ?
                                                                                ""
                                                                                :
                                                                                "&partialUsernameSearch=" + partialUsernameSearch
                                                                               )
                                                                              ); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getByCompanyId_ExcludeSureSimPortalUsers(inviewCompanyId: number, partialUsernameSearch: string | undefined): Observable<InviewUserDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>inviewCompanyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const inviewCompanyIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<InviewUserDTO[]>(environment.eSimApi +
                                                                               eSimApiPaths.InviewUsers + "/" +
                                                                               eSimApiPaths.InviewUsersExcludeSureSimPortalUsers +
                                                                               "?inviewCompanyIdEncSS=" + inviewCompanyIdEncSS +
                                                                               (partialUsernameSearch==undefined || partialUsernameSearch.trim()==""
                                                                                ?
                                                                                ""
                                                                                :
                                                                                "&partialUsernameSearch=" + partialUsernameSearch
                                                                               )
                                                                              ); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getIdAndDescription(inviewCompanyId: number): Observable<IdAndDescriptionDTO[]> {
    try {
      return this.getByCompanyId(inviewCompanyId)
      .pipe(
        map(x => x.map(this.idAndDescriptionConverter))
      );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getByCompanyIdAndCostCentreLv1Id(inviewCompanyId: number, costCentreLv1Id: number): Observable<InviewUserDTO[]> {
    try {
      return this.getByCompanyId(inviewCompanyId)
      .pipe(
        map(x => x.filter(x => x.costCenterID==costCentreLv1Id)),
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
  public getIdAndDescription_ByCompanyIdAndCostCentreLv1Id(inviewCompanyId: number, costCentreLv1Id: number): Observable<IdAndDescriptionDTO[]> {
    try {
      return this.getByCompanyIdAndCostCentreLv1Id(inviewCompanyId, costCentreLv1Id)
             .pipe(
               map(x => x.map(this.idAndDescriptionConverter))
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  private idAndDescriptionConverter(inviewUser: InviewUserDTO) {
    return {id: inviewUser.userID, description: inviewUser.email};
  }

  public post(inviewUser: InviewUserDTO): Observable<InviewUserDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(inviewUser), true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const inviewUserEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.InviewUsers +
                                                               "?inviewUserEncSS=" + inviewUserEncSS, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
      
    public put(inviewUser: InviewUserDTO): Observable<InviewUserDTO> {
      try {
        return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(inviewUser), true)
               .pipe(
                  switchMap((encResult: StringResultDTO) => {
                              const inviewUserEncSS=encResult.result;
                              
                              return this.httpClientService.put(environment.eSimApi +
                                                                eSimApiPaths.InviewUsers +
                                                                "?id=" + inviewUser.userID +
                                                                "&inviewUserEncSS=" + inviewUserEncSS, undefined, {}); 
                           })
                    );
      }
      catch(e) {
        this.exceptionsService.handleException(<Error>e);
        return of();
      }
    }
}
